var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9315 0.93288C65.6257 1.99959 66.1344 4.23774 65.0677 5.93192L28.5492 63.9319C27.9346 64.908 26.8922 65.5334 25.7417 65.6161C24.5912 65.6989 23.47 65.2292 22.722 64.3512L1.24056 39.1338C-0.0576865 37.6097 0.125347 35.3218 1.64938 34.0236C3.17341 32.7253 5.46133 32.9084 6.75958 34.4324L25.0423 55.8947L58.9325 2.06903C59.9992 0.37484 62.2373 -0.13383 63.9315 0.93288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkWhite);
export default __webpack_public_path__ + "static/media/CheckmarkWhite.53d8be149ffc7923d08c5bf93e36f778.svg";
export { ForwardRef as ReactComponent };